module.exports = __webpack_public_path__ + "img/f_u1_plaidskirt.fa2c35d8.jpg";